if (!customElements.get('pp-sticky-atc')) {
  customElements.define(
    'pp-sticky-atc',
    class PpStickyAtc extends HTMLElement {
      connectedCallback() {
        this.mainButton = document.querySelector('product-form .product-form__submit');
        this.button = this.querySelector('.pp-sticky__button');
        this.priceEl = this.querySelector('[data-sticky-price]');
        if (!this.mainButton || !this.button) return;

        this.button.addEventListener('click', () => {
          if (!this.mainButton.disabled) this.mainButton.click();
        });

        this.observer = new IntersectionObserver(([entry]) => {
          const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.toggle(passed);
        });
        this.observer.observe(this.mainButton);

        // Varyant değişince fiyatı ve stok durumunu ana formdan al
        this.mutation = new MutationObserver(() => this.sync());
        this.mutation.observe(this.mainButton, { attributes: true, attributeFilter: ['disabled'] });
        const price = document.querySelector('.product__info-container .price');
        if (price) this.mutation.observe(price.parentElement, { childList: true, subtree: true, characterData: true });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.mutation?.disconnect();
      }

      toggle(show) {
        this.classList.toggle('is-visible', show);
        this.setAttribute('aria-hidden', String(!show));
        this.button.tabIndex = show ? 0 : -1;
        document.body.classList.toggle('pp-sticky-visible', show);
      }

      sync() {
        this.button.disabled = this.mainButton.disabled;
        const price = document.querySelector('.product__info-container .price');
        if (!price || !this.priceEl) return;
        const current = price.classList.contains('price--on-sale')
          ? price.querySelector('.price__sale .price-item--sale')
          : price.querySelector('.price__regular .price-item--regular');
        if (current) this.priceEl.textContent = current.textContent.trim();
      }
    }
  );
}
